// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_b2-4";
export var collapsed = "_b2-1";
export var headerBar = "_b2-0";
export var leftHeaderContent = "_b2-3";
export var subjectContainer = "_b2-2";